export { AiChatConversationParticipant } from '../entities'
export type { AiChatConversationParticipant as default } from '../entities'
